import dayjs from 'dayjs';

export const isExpired = (date) => {
  return dayjs(date).isBefore(dayjs(), 'day');
};

export const isToday = (date) => {
  return dayjs(date).isSame(dayjs(), 'day');
};
